jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

$("a.btn-primary, a.btn-secondary, button.btn-primary")
  .filter(function () {
    return !$(this).hasClass("level2"); // Exclude elements with class "level2"
  })
  .each(function () {
    var originalText = $(this)
      .contents()
      .filter(function () {
        return this.nodeType === 3; // Select only text nodes
      })
      .text()
      .trim();

    if (originalText) {
      $(this).html(
        '<div class="slide-in-bottom"><span data-hover="' +
          originalText +
          '">' +
          originalText +
          "</span></div>"
      );
    }
  });

$(".employees-slider .read-more").on("click", function () {
  $(this).siblings(".description").slideToggle(400);
});

$(".video-wrapper").on("click", ".video-thumbnail, .icon-play", function () {
  var container = $(this).closest(".video-wrapper");
  var videoId = container.find(".video-thumbnail").data("video-id");

  var iframe =
    '<div class="youtube-video">' +
    '<iframe width="558" height="369" src="https://www.youtube.com/embed/' +
    videoId +
    '?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>' +
    "</div>";

  container.html(iframe);
});

$("#newsletter-subscribe").on("submit", function (e) {
  e.preventDefault();
  var form = $(this)[0];
  if (form.checkValidity() === false) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
  $.ajax({
    type: "post",
    url: $(this).attr("action"),
    data: $(this).serialize(),
    success: function (data) {
      $("#submitedEmail").html($("#subscribeEmail").val());
      $("#newsletterModal").modal();
    },
  });
});

(function () {
  "use strict";
  window.addEventListener(
    "load",
    function () {
      var forms = document.getElementsByClassName("needs-validation");
      var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            console.log("form submitted.");
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
              $(form).addClass("has-errors");
            } else {
              $(form).removeClass("has-errors");
              $(form).addClass("submitting");
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    false
  );
})();

$(".hamburger").on("click", function () {
  $(".hamburger").toggleClass("is-active");
  $(".header-container").toggleClass("navi-open");
  $(".navigation-wrapper").toggleClass("navi-open");
  $("body").toggleClass("navi-open");
});

$(".show-more").on("click", function () {
  $(this).closest("li.level1").find(".ul-wrapper").toggle();
  $(this).closest("li.level1").toggleClass("open");
});

if ($(".opinions-slider").length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    var splideOf = new Splide(".opinions-slider", {
      pagination: false,
      arrows: false,
      drag: false,
      autoplay: false,
      speed: 3000,
      rewind: false,
      perPage: 2,
      gap: "24px",
      breakpoints: {
        992: {
          arrows: true,
          perPage: 1,
          drag: true,
          rewind: true,
        },
      },
    }).mount();

    // Disable arrows + drag if only 1 slide
    function enforceSingleSlideRules() {
      if (splideOf.length === 1) {
        splideOf.options = {
          arrows: false,
          drag: false,
          rewind: false,
        };
      }
    }

    // Run once on load
    enforceSingleSlideRules();
    
    // Run again on resize
    splideOf.on("resize", enforceSingleSlideRules);
  });
}

if ($(".banner-logos").length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    var splideHomePartner = new Splide(".banner-logos", {
      type: "loop",
      drag: "free",
      focus: "center",
      gap: "96px",
      autoWidth: true,
      pagination: false,
      arrows: false,
      autoScroll: {
        speed: 0.5,
      },
    }).mount(window.splide.Extensions);
  });
}

if ($(".offer-list-slider").length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    var splideofferList = new Splide(".offer-list-slider", {
      pagination: false,
      arrows: false,
      drag: false,
      autoplay: false,
      speed: 3000,
      rewind: false,
      perPage: 3,
      gap: "24px",
      breakpoints: {
        992: {
          pagination: true,
          perPage: 1,
          drag: true,
          rewind: true,
        },
      },
    }).mount();
  });
}
